/** @jsx jsx */
import React, { useState, useEffect } from 'react';
import { jsx } from 'theme-ui';
import { Link } from 'gatsby';
import {
  FaBars,
  FaInstagram,
  FaPodcast,
  FaTimes,
  FaYoutube,
  FaTwitter,
  FaFacebookF,
  FaLinkedinIn,
  FaChevronDown,
  FaLock,
} from 'react-icons/fa';
import AdoptEmbryoButton from '../Common/AdoptEmbryoButton';
import DonateEmbryoButton from '../Common/DonateEmbryoButton';
//import NotificationButton from '../Common/NotificationButton';

const Navbar = () => {
  const [mobile, setMobile] = useState(true);
  const [menuVisible, setMenuVisible] = useState(false);
  const [width, setWidth] = useState(0);

  const menuItems = [
    {
      name: 'About Us',
      slug: '/about',
      items: [
        {
          name: 'Board of Directors',
          slug: '/about/board',
        },
        {
          name: 'Contact Us',
          slug: '/contact-us',
        },
      ],
    },
    {
      name: 'Donation',
      slug: '/donation',
    },
    {
      name: 'Adoption',
      slug: '/adoption',
    },
    {
      name: 'Support Us',
      slug: '/support-nedc',
      items: [
        {
          name: 'Donate with Cryptocurrency',
          slug: '/donate-with-cryptocurrency',
        },
      ],
    },
    {
      name: 'Personal Stories',
      slug: '/personal-embryo-adoption-stories',
    },
    {
      name: 'Books',
      slug: '/training-wheels',
    },
    {
      name: 'Free Consultations',
      slug: '/free-consultations',
    },
  ];

  /**
   * Updates width when resized for responsiveness of menu item
   */
  const updateWidth = () => {
    const windowWidth = window.innerWidth;
    setWidth(windowWidth);
    setMenuVisible(false);
  };

  useEffect(() => {
    updateWidth();
    window.addEventListener('resize', updateWidth);
    if (width <= 1366) {
      setMobile(true);
    } else {
      setMobile(false);
    }
    return () => window.removeEventListener('resize', updateWidth);
  }, [width]);

  return (
    <>
      <nav
        sx={{
          position: 'sticky',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 999,
          boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.5)',
          bg: '#fff',
        }}
      >
        <div
          sx={{
            color: '#999999',
            bg: '#61A19E',
            px: '1rem',
            'a, button': {
              color: '#FFFFFF',
              fontWeight: '700',
            },
          }}
        >
          <div
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'end',
              gap: '0.25rem',
              maxWidth: ' 1400px',
              margin: 'auto',
              height: '50px',
              'a, button': {
                color: '#fff',
                p: '0.75rem 0.5rem',
                display: 'flex',
                gap: '0.25rem',
                alignItems: 'center',

                '&:hover': {
                  color: '#F7A496',
                },
              },
            }}
          > 
            <a
              href="http://www.linkedin.com/company/national-embryo-donation-center"
              target="_blank"
              rel="noopener noreferrer"
              title="Follow us on Linkedin"
            >
              <FaLinkedinIn />
            </a>
            <a
              href="http://www.twitter.com/embryodonation"
              target="_blank"
              rel="noopener noreferrer"
              title="Follow us on Twitter"
            >
              <FaTwitter />
            </a>
            <a
              href="http://www.facebook.com/embryodonation"
              target="_blank"
              rel="noopener noreferrer"
              title="Follow us on Facebook"
            >
              <FaFacebookF />
            </a>
            <a
              href="http://www.youtube.com/NEDCKnoxville"
              target="_blank"
              rel="noopener noreferrer"
              title="Watch us on Youtube"
            >
              <FaYoutube />
            </a>
            <a
              href="https://www.instagram.com/nedcknoxtn/"
              target="_blank"
              rel="noopener noreferrer"
              title="Follow us on Instagram"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.podomatic.com/podcasts/mmellinger"
              target="_blank"
              rel="noopener noreferrer"
              title="Listen to our Podcast"
            >
              <FaPodcast />
            </a>
            <a href="https://members.embryodonation.org/">
              <FaLock /> Login
            </a>
          </div>
        </div>
        <div
          sx={{
            maxWidth: ' 1400px',
            mx: 'auto',
            position: 'relative',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '1rem',
            px: '1rem',
          }}
        >
          <div sx={{ py: '1rem', flexShrink: '1' }}>
            <Link to="/" sx={{ minWidth: '100px', display: 'block' }} title={'Home'}>
              <img src="/images/logo.png" alt="" width="164px" />
            </Link>
          </div>
          <div
            sx={{
              display: 'flex',
              gap: '0.5rem',
              alignItems: 'center',
              'a, button': {
                color: '#666',
                fontSize: '1rem',
                fontWeight: '700',
                padding: '0.75rem 0.5rem',
                display: 'flex',
                gap: '0.5rem',
                alignItems: 'center',
                justifyContent: 'center',
                //textTransform: 'uppercase'
              },
              'a:hover': {
                color: '#4B938EE5',
              },
            }}
          >
            {!mobile &&
              menuItems.map((menuItem) => (
                <div
                  key={menuItem.name}
                  sx={{
                    position: 'relative',
                    'div a': {
                      display: 'none',
                    },
                    '&:hover': {
                      div: {
                        top: '100%',
                        position: 'absolute',
                        pt: '1rem',
                      },
                      'div a': {
                        background: '#fff',
                        borderRadius: '8px',
                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                        //position: 'absolute',
                        pt: '1rem',
                        top: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        textAlign: 'center',
                        minWidth: '250px',
                      },
                    },
                  }}
                >
                  <Link key={menuItem.slug} to={menuItem.slug} title={menuItem.name}>
                    {menuItem.name}
                    {menuItem?.items && <FaChevronDown />}
                  </Link>

                  {menuItem?.items && (
                    <div>
                      {menuItem.items.map((item) => (
                        <Link key={item.slug} to={item.slug} title={item.name}>
                          {item.name}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            <div sx={{ display: ['none', null, 'flex'], gap: '0.5rem', flexWrap: 'wrap' }}>
              <AdoptEmbryoButton />
              
              <DonateEmbryoButton/>

            </div>

            {mobile && (
              <button
                aria-haspopup="true"
                aria-controls="mobile-menu"
                aria-expanded={menuVisible ? 'false' : 'true'}
                onClick={() => setMenuVisible((prev) => !prev)}
              >
                {menuVisible ? <FaTimes /> : <FaBars />}
              </button>
            )}
          </div>
        </div>
        {menuVisible && (
          <div
            id="mobile-menu"
            aria-expanded={menuVisible ? 'true' : 'false'}
            sx={{
              position: 'absolute',
              top: '100%',
              left: 0,
              right: 0,
              bg: '#fff',
              zIndex: '999',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div
              sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                px: '2rem',
                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                a: {
                  color: '#666',
                  fontSize: '1rem',
                  padding: '1rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                },
                'a:hover': {
                  color: '#4B938EE5',
                },
              }}
            >
              {menuItems.map((menuItem) => (
                <div
                  key={menuItem.name}
                  sx={{
                    position: 'relative',

                    'div a': {
                      display: 'flex',
                      justifyContent: 'center',
                      textAlign: 'center',
                      minWidth: '250px',
                    },
                  }}
                >
                  <Link
                    aria-role="menuitem"
                    key={menuItem.slug}
                    to={menuItem.slug}
                    title={menuItem.name}
                  >
                    {menuItem.name}
                  </Link>

                  {menuItem?.items && (
                    <div>
                      {menuItem.items.map((item) => (
                        <Link aria-role="menuitem" key={item.slug} to={item.slug} title={item.name}>
                          {item.name}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ))}
              <div
                sx={{
                  display: ['flex', null, 'none'],
                  gap: '0.5rem',
                  flexWrap: 'wrap',
                  pb: ' 1rem',
                  justifyContent: 'center',
                }}
              >
                <AdoptEmbryoButton />
                <a
                  href="https://members.embryodonation.org/"
                  sx={{
                    display: 'block',
                    fontSize: '1rem',
                    color: ' #000 !important',
                    p: '1rem 1.5rem !important',
                    borderRadius: '8px',
                    textAlign: 'center',
                    minWidth: '175px',
                    border: '1px solid #AAD2D1',
                    '&:hover': {
                      background: ' transparent',
                      color: ' #F7A496 !important',
                    },
                  }}
                >
                  Donate Embryos
                </a>
              </div>
            </div>
          </div>
        )}
      </nav>
    </>
  );
};

export default Navbar;
